var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 2.8H2.8C2.32261 2.8 1.86477 2.98964 1.52721 3.32721C1.18964 3.66477 1 4.12261 1 4.6V15.4C1 15.8774 1.18964 16.3352 1.52721 16.6728C1.86477 17.0104 2.32261 17.2 2.8 17.2H9.1M12.7 2.8H13.6C14.0774 2.8 14.5352 2.98964 14.8728 3.32721C15.2104 3.66477 15.4 4.12261 15.4 4.6V5.5M15.4 14.5V15.4C15.4 15.8774 15.2104 16.3352 14.8728 16.6728C14.5352 17.0104 14.0774 17.2 13.6 17.2H12.7M15.4 9.1V10.9M8.2 1V19",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderIconGray);
export default __webpack_public_path__ + "static/media/SliderIconGray.183bd1a212bc2b5d61d698c7c7be51e6.svg";
export { ForwardRef as ReactComponent };